import { useState } from 'react'
import { Sheet } from '../ui/Sheet'
import { purchaseLane } from './checkout'
import { billingUiOn } from './flags'
import { isPaidPlan, planName, resetsIn, useBilling } from './plan'
import { PlusSheet } from './PlusSheet'
import { hideQuotaPrompt, useQuotaPrompt } from './quotaPrompt'
import { useClock } from './useClock'

/**
 * What the mic says when today's allowance is gone — owner, 2026-09-09: free tier
 * 達到用量之後按下 microphone 需要提示需要升級帳號; plus tier 達到用量之後, 系統正在
 * 擴充, 之後會配備更好方案. Both name when the allowance comes back (UTC midnight),
 * because "try again later" without a time is a door with no handle.
 *
 * The free sentence never quotes the free limit: the tier is described as
 * "limited" everywhere (owner's addendum), and the number a person is told is the
 * one they would get by upgrading.
 */
export function QuotaSheet() {
  const open = useQuotaPrompt()
  // A build without the subscription surfaces never shows the paywall (flags.ts).
  if (!open || !billingUiOn()) return null
  return <QuotaBody onClose={hideQuotaPrompt} />
}

function QuotaBody({ onClose }: { onClose: () => void }) {
  const { usage } = useBilling()
  const now = useClock()
  const plan = planName()
  const lane = purchaseLane()
  // "Upgrade to Plus" opens the paywall (PlusSheet) over this sheet — the disclosure
  // first, the store's own sheet from there; a purchase closes both.
  const [paywall, setPaywall] = useState(false)
  const reset = usage ? `Resets ${resetsIn(usage.resetsAt, now)}.` : 'Resets at midnight UTC.'

  return (
    <>
      <Sheet
        title="Voice input limit"
        onClose={onClose}
        actions={
          isPaidPlan(plan) ? (
            <button type="button" className="sheet-btn primary" onClick={onClose}>
              OK
            </button>
          ) : (
            <>
              <button type="button" className="sheet-btn" onClick={onClose}>
                Not now
              </button>
              {lane !== 'none' && (
                <button type="button" className="sheet-btn primary" onClick={() => setPaywall(true)}>
                  Upgrade to Plus
                </button>
              )}
            </>
          )
        }
      >
        {isPaidPlan(plan) ? (
          <p className="quota-msg">
            You’ve used today’s hour of voice input. We’re expanding — a bigger plan is on the way.
          </p>
        ) : (
          <p className="quota-msg">
            You’ve reached today’s limit for voice input. Upgrade to Plus for an hour a day.
          </p>
        )}
        <p className="quota-reset">{reset}</p>
      </Sheet>
      {paywall && (
        <PlusSheet
          onClose={() => setPaywall(false)}
          onDone={() => {
            setPaywall(false)
            onClose()
          }}
        />
      )}
    </>
  )
}
